// extracted by mini-css-extract-plugin
export default {"defaultWrapper":"BrandProducts_defaultWrapper__Ik6gW","suppressHomeLink":"BrandProducts_suppressHomeLink__QoPuZ"};